import { AlertTriangle, SearchX, RotateCw } from 'lucide-react';
import { useI18n } from '@/context/I18nContext';

interface ErrorStateProps {
  message: string;
  isNotFound?: boolean;
  onRetry?: () => void;
  showReload?: boolean;
  reloadLabel?: string;
}

export function ErrorState({
  message,
  isNotFound,
  onRetry,
  showReload = true,
  reloadLabel,
}: ErrorStateProps) {
  const { t } = useI18n();

  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3 text-center">
      {isNotFound ? (
        <SearchX size={32} className="text-text-muted" />
      ) : (
        <AlertTriangle size={32} className="text-red" />
      )}
      <p className="text-sm text-text-secondary max-w-sm">{message}</p>
      {showReload && (
        <button
          type="button"
          onClick={() => {
            if (onRetry) {
              onRetry();
            } else {
              window.location.reload();
            }
          }}
          className="mt-1 inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-md text-xs font-medium bg-accent text-white hover:bg-accent-hover transition-colors cursor-pointer"
        >
          <RotateCw size={13} />
          <span>{reloadLabel || t('common.reloadPage')}</span>
        </button>
      )}
    </div>
  );
}

